var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useRef, useState } from 'react';
import { filter } from 'rxjs/operators';
import styled from 'styled-components';
import { DialogActions, DialogContent, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';
import MapManagerContext from '../../context/map-manager-context';
import WindowEventContext from '../../context/window-event-context';
import { delay } from '../../helpers/dom-utils';
import useMapTranslation from '../../hooks/useMapTranslation';
import { showIndicator_AC } from '../../store/s80_touchpanel.actions';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: fixed;\n  top: 20px;\n  left: 20px;\n"], ["\n  display: fixed;\n  top: 20px;\n  left: 20px;\n"])));
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 1200px;\n  height: 1100px;\n"], ["\n  width: 1200px;\n  height: 1100px;\n"])));
var StyledDialog = styled(Dialog)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: white;\n  & .MuiDialog-paper {\n    min-width: 1200px;\n    min-height: 1200px;\n  }\n  & .MuiDialogContent-root {\n    padding: 0;\n  }\n  & .MuiDialogContent-root:first-child {\n    padding: 0;\n  }\n  & .MuiDialogTitle-root {\n    padding: 3px 24px;\n  }\n"], ["\n  color: white;\n  & .MuiDialog-paper {\n    min-width: 1200px;\n    min-height: 1200px;\n  }\n  & .MuiDialogContent-root {\n    padding: 0;\n  }\n  & .MuiDialogContent-root:first-child {\n    padding: 0;\n  }\n  & .MuiDialogTitle-root {\n    padding: 3px 24px;\n  }\n"])));
var StyledDialogActions = styled(DialogActions)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: rgb(43, 56, 86);\n  color: #eee917;\n"], ["\n  background-color: rgb(43, 56, 86);\n  color: #eee917;\n"])));
var StyledDialogContent = styled(DialogContent)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  background-color: rgb(43, 56, 86);\n  color: #eee917;\n"], ["\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  background-color: rgb(43, 56, 86);\n  color: #eee917;\n"])));
var StyledButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  height: 45px;\n  width: 91px;\n  box-sizing: border-box;\n  color: #eee917;\n  border: 1.5px solid;\n  outline: none;\n  box-sizing: border-box;\n  border-radius: 0px;\n  cursor: pointer;\n  font-family: Arial;\n  border-left-color: rgb(187, 187, 187);\n  border-top-color: rgb(187, 187, 187);\n  border-right-color: rgb(0, 0, 0);\n  border-bottom-color: rgb(0, 0, 0);\n  background-color: rgb(43, 56, 86);\n"], ["\n  height: 45px;\n  width: 91px;\n  box-sizing: border-box;\n  color: #eee917;\n  border: 1.5px solid;\n  outline: none;\n  box-sizing: border-box;\n  border-radius: 0px;\n  cursor: pointer;\n  font-family: Arial;\n  border-left-color: rgb(187, 187, 187);\n  border-top-color: rgb(187, 187, 187);\n  border-right-color: rgb(0, 0, 0);\n  border-bottom-color: rgb(0, 0, 0);\n  background-color: rgb(43, 56, 86);\n"])));
var CaptureBTWidget = function (_a) {
    var className = _a.className, open = _a.open, onPointConfirm = _a.onPointConfirm, buttonId = _a.buttonId, handleClose = _a.handleClose;
    var _b = useContext(MapManagerContext), mapImage = _b.mapImage, leftUpperCorner = _b.leftUpperCorner, rightLowerCorner = _b.rightLowerCorner;
    var _c = useContext(WindowEventContext), actionStream$ = _c.actionStream$, _onDispatchAction = _c._onDispatchAction;
    var _d = useMapTranslation(leftUpperCorner, rightLowerCorner), xyToLatLang = _d.xyToLatLang, latLangToXY = _d.latLangToXY;
    var _e = useState({
        latV: '0',
        latH: '',
        longV: '0',
        longH: '',
        x: undefined,
        y: undefined,
    }), pinLocation = _e[0], setPinLocation = _e[1];
    var ref = useRef(null);
    var okButtonRef = useRef(null);
    var showButtonIndicator = function () {
        return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var rect, x, y;
            return __generator(this, function (_a) {
                rect = okButtonRef.current.getBoundingClientRect();
                x = rect.x + rect.width / 2 - 20;
                y = rect.y - 15;
                _onDispatchAction(showIndicator_AC(x, y));
                resolve(true);
                return [2];
            });
        }); });
    };
    useEffect(function () {
        console.log('CaptureBTWidget actionStream', actionStream$, actionStream$.getActions());
        var subscription = actionStream$
            .getActions()
            .pipe(filter(function (action) { return action.type === 'INTERNAL_SELECT_DEMO_POINT'; }), filter(function (action) { return action.payload.buttonId === buttonId; }))
            .subscribe(function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, latV, latH, longV, longH, latitude, longitude, _b, x, y;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        console.log('CaptureBTWidget action', action);
                        _a = action.payload, latV = _a.latV, latH = _a.latH, longV = _a.longV, longH = _a.longH;
                        latitude = latV + " " + latH;
                        longitude = longV + " " + longH;
                        console.group('trying to translate');
                        _b = latLangToXY(longitude, latitude, {
                            clientWidth: 1200,
                            clientHeight: 1100,
                        }), x = _b[0], y = _b[1];
                        console.log('trying to translate in notswindow renderer', {
                            longitude: longitude,
                            latitude: latitude,
                            x: x,
                            y: y,
                        });
                        console.groupEnd();
                        console.log('CaptureBTWidget x y ', x, y, latitude, longitude);
                        return [4, delay(500)];
                    case 1:
                        _c.sent();
                        _onDispatchAction(showIndicator_AC(x + 185, y - 15));
                        return [4, delay(2000)];
                    case 2:
                        _c.sent();
                        console.log('CaptureBTWidget setting location', latV, latH, longV, longH);
                        setPinLocation(function (pLocation) { return (__assign(__assign({}, pLocation), { latV: latV,
                            longV: longV,
                            latH: latH,
                            longH: longH,
                            x: x,
                            y: y })); });
                        return [4, showButtonIndicator()];
                    case 3:
                        _c.sent();
                        return [4, delay(2000)];
                    case 4:
                        _c.sent();
                        onPointConfirm({
                            latV: latV,
                            longV: longV,
                            latH: latH,
                            longH: longH,
                        });
                        return [2];
                }
            });
        }); });
        return function () {
            if (subscription && subscription.unsubscribe) {
                subscription.unsubscribe();
            }
        };
    }, []);
    var onOkClick = function () {
        console.log('CaptureBTWidget sending location', pinLocation);
        onPointConfirm(pinLocation);
    };
    return (React.createElement(Container, { className: className },
        React.createElement(StyledDialog, { open: open },
            React.createElement(StyledDialogContent, null,
                React.createElement(Image, { onClick: function (evt) {
                        var _a, _b;
                        console.log(evt.pageX, evt.pageY);
                        console.log(ref === null || ref === void 0 ? void 0 : ref.current, (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetTop);
                        var _c = (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect(), x = _c.x, y = _c.y, left = _c.left, top = _c.top;
                        console.log(x, y);
                        console.group('click');
                        console.log('CaptureBTWidget click action');
                        var _d = xyToLatLang(evt.clientX - left, evt.clientY - top, ref.current), latV = _d[0], latH = _d[1], longV = _d[2], longH = _d[3];
                        console.groupEnd();
                        setPinLocation({
                            latV: latV,
                            longV: longV,
                            latH: latH,
                            longH: longH,
                            x: evt.clientX - left - 10,
                            y: evt.clientY - top - 10,
                        });
                    }, ref: ref, src: mapImage }),
                React.createElement(Typography, { align: "center" },
                    "Pin: Lat: ",
                    pinLocation.latV,
                    " ",
                    pinLocation.latH,
                    " Long:",
                    ' ',
                    pinLocation.longV,
                    " ",
                    pinLocation.longH),
                pinLocation.x && (React.createElement(LocationSearchingIcon, { style: {
                        position: 'absolute',
                        left: (pinLocation === null || pinLocation === void 0 ? void 0 : pinLocation.x) + "px",
                        top: (pinLocation === null || pinLocation === void 0 ? void 0 : pinLocation.y) + "px",
                        width: '20px',
                        height: '20px',
                        display: pinLocation ? 'block' : 'none',
                    } }))),
            React.createElement(StyledDialogActions, null,
                React.createElement(StyledButton, { ref: okButtonRef, onClick: onOkClick }, "OK"),
                React.createElement(StyledButton, { onClick: handleClose }, "Cancel")))));
};
export default CaptureBTWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map